// @flow

export const ASSETS_GROUPS: Object = Object.freeze({
	IMAGE: "PHOTO",
	AUDIO: "AUDIO",
	VIDEO: "VIDEO",
	TXT: "FILE",
});

export const ASSETS_FORMATS: Object = Object.freeze({
	jpg: ASSETS_GROUPS.IMAGE,
	jpeg: ASSETS_GROUPS.IMAGE,
	gif: ASSETS_GROUPS.IMAGE,
	png: ASSETS_GROUPS.IMAGE,
	pdf: ASSETS_GROUPS.IMAGE,
	mp4: ASSETS_GROUPS.VIDEO,
	mov: ASSETS_GROUPS.VIDEO,
	mp3: ASSETS_GROUPS.AUDIO,
	word: ASSETS_GROUPS.TXT,
	doc: ASSETS_GROUPS.TXT,
	docx: ASSETS_GROUPS.TXT,
	bmp: ASSETS_GROUPS.IMAGE,
	ico: ASSETS_GROUPS.IMAGE,
	tiff: ASSETS_GROUPS.IMAGE,
	eps: ASSETS_GROUPS.IMAGE,
	jpc: ASSETS_GROUPS.IMAGE,
	jp2: ASSETS_GROUPS.IMAGE,
	psd: ASSETS_GROUPS.IMAGE,
	webp: ASSETS_GROUPS.IMAGE,
	svg: ASSETS_GROUPS.IMAGE,
	wdp: ASSETS_GROUPS.IMAGE,
	hpx: ASSETS_GROUPS.IMAGE,
	djvu: ASSETS_GROUPS.IMAGE,
	ai: ASSETS_GROUPS.IMAGE,
	flif: ASSETS_GROUPS.IMAGE,
	bpg: ASSETS_GROUPS.IMAGE,
	miff: ASSETS_GROUPS.IMAGE,
	tga: ASSETS_GROUPS.IMAGE,

	css: ASSETS_GROUPS.TXT,
	js: ASSETS_GROUPS.TXT,
	zip: ASSETS_GROUPS.TXT,

	aac: ASSETS_GROUPS.AUDIO,
	ogg: ASSETS_GROUPS.AUDIO,
	m4a: ASSETS_GROUPS.AUDIO,
	wav: ASSETS_GROUPS.AUDIO,
	aiff: ASSETS_GROUPS.AUDIO,
	flac: ASSETS_GROUPS.AUDIO,

	avi: ASSETS_GROUPS.VIDEO,
	"3gp": ASSETS_GROUPS.VIDEO,
	"3g2": ASSETS_GROUPS.VIDEO,
	wmv: ASSETS_GROUPS.VIDEO,
	mpeg: ASSETS_GROUPS.VIDEO,
	mkv: ASSETS_GROUPS.VIDEO,
	webm: ASSETS_GROUPS.VIDEO,
	ogv: ASSETS_GROUPS.VIDEO,
	flv: ASSETS_GROUPS.VIDEO,
	m3u8: ASSETS_GROUPS.VIDEO,
	ts: ASSETS_GROUPS.VIDEO,
	mpd: ASSETS_GROUPS.VIDEO,
	quicktime: ASSETS_GROUPS.VIDEO,
});
